import {
  notifySuccess,
  notifyError,
} from "../../../redux/actions/notificacaoActions";
import { t } from "adapters/i18n";
import FormulaManager from "../formulaManager";
import formulaService from "../formulaService";
import {
  deletarFormula,
  listarFormulasFazenda,
  exibirCarregando,
  restaurarFormula,
  listarEpocasFormula,
  listarCategoriasFormula,
} from "./formulaActions";

export const criarFormula = (Formula) => async (dispatch) => {
  try {
    await FormulaManager.adicionarFormula(Formula);

    dispatch(
      notifySuccess({
        mensagem: t("success:formulation.create-success"),
      })
    );
  } catch ({ response }) {
    let mensagem = t("errors:formulation.create-error");

    if (response && response.status && response.status === 409) {
      mensagem = t("errors:formulation.name-exists");
    }

    dispatch(
      notifyError({
        mensagem,
      })
    );

    throw new Error(mensagem);
  }
};

export const atualizarFormula = (idFormula, Formula) => async (dispatch) => {
  try {
    await FormulaManager.atualizarFormula(idFormula, Formula);
    dispatch(
      notifySuccess({
        mensagem: t("success:formulation.update-success"),
      })
    );
  } catch ({ response }) {
    let mensagem = t("errors:formulation.update-error");

    if (response && response.status && response.status === 409) {
      mensagem = t("errors:formulation.name-exists");
    }

    dispatch(
      notifyError({
        mensagem,
      })
    );
    throw new Error(mensagem);
  }
};

export const excluirFormula = (idFormula) => async (dispatch) => {
  try {
    await FormulaManager.excluirFormula(idFormula);
    dispatch(deletarFormula());
    dispatch(
      notifySuccess({
        mensagem: t("success:formulation.delete-success"),
      })
    );
  } catch (error) {
    dispatch(
      notifyError({
        mensagem: t("errors:formulation.delete-error"),
      })
    );
  }
};

export const desexcluirFormula =
  (idFormula, ingredientes) => async (dispatch) => {
    try {
      await FormulaManager.desexcluirFormula(idFormula);
      dispatch(restaurarFormula());
      if (ingredientes && ingredientes.length > 0) {
        dispatch(
          notifySuccess({
            mensagem: t("success:formulation.update-ingredient-success"),
          })
        );
      } else {
        dispatch(
          notifySuccess({
            mensagem: t("success:formulation.update-success"),
          })
        );
      }
    } catch (error) {
      const message = error?.response?.data?.body?.message
        ? error.response.data.body.message
        : t("errors:formulation.update-error");
      dispatch(
        notifyError({
          mensagem: message,
        })
      );
    }
  };

export const obterFormulasFazenda =
  (pegarFormulasDeletadas) => async (dispatch, getState) => {
    dispatch(exibirCarregando(true));
    try {
      const { fazenda } = getState();
      const formulasFazenda = await FormulaManager.obterFormulasFazenda(
        fazenda.FazendaSelecionada,
        pegarFormulasDeletadas
      );
      dispatch(listarFormulasFazenda(formulasFazenda));
    } catch (error) {
      dispatch(listarFormulasFazenda([]));
      dispatch(
        notifyError({
          mensagem: t("errors:formulation.list-error"),
        })
      );
    } finally {
      dispatch(exibirCarregando(false));
    }
  };

export const obterEpocasFormula = () => async (dispatch) => {
  dispatch(exibirCarregando(true));
  try {
    const epocasFormula = await FormulaManager.obterEpocasFormula();

    dispatch(listarEpocasFormula(epocasFormula));
  } catch (error) {
    dispatch(listarEpocasFormula([]));
    dispatch(
      notifyError({
        mensagem: t("errors:formulation.list-epochs-error"),
      })
    );
  } finally {
    dispatch(exibirCarregando(false));
  }
};

export const obterCategoriasFormula = () => async (dispatch) => {
  dispatch(exibirCarregando(true));
  try {
    const categoriasFormula = await FormulaManager.obterCategoriasFormula();
    dispatch(listarCategoriasFormula(categoriasFormula));
  } catch (error) {
    dispatch(listarCategoriasFormula([]));
    dispatch(
      notifyError({
        mensagem: t("errors:formulation.list-categories-error"),
      })
    );
  } finally {
    dispatch(exibirCarregando(false));
  }
};

export const copyFormula =
  (idFormula, copiedFormula) => async (dispatch, getState) => {
    dispatch(exibirCarregando(true));
    try {
      const { fazenda } = getState();
      await excluirFormula(idFormula)(dispatch);
      const response = await formulaService.adicionarFormula(copiedFormula);
      const newFormula = await formulaService.buscarFormulacaoPorId(
        fazenda.fazendaSelecionada,
        response.data.body.IdFormula
      );
      dispatch(
        notifySuccess({
          mensagem: t("success:formulation.create-success"),
        })
      );
      return newFormula;
    } catch (error) {
      dispatch(
        notifyError({
          mensagem: t("errors:formulation.copy-error"),
        })
      );
      return null;
    } finally {
      dispatch(exibirCarregando(false));
    }
  };
